import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';
import styles from './options.scss';

class PasswordInput extends React.Component {
    static propTypes = {
        changeHandler: PropTypes.func.isRequired,
    };

    render() {
        return (
            <div className={styles.passwordWrapper}>
                <label htmlFor="invigilator-password-input">{t('options.invigilatorPasswordLabel')}</label>
                <input
                    id="invigilator-password-input"
                    type="password"
                    name="invigilatorPassword"
                    onChange={this.props.changeHandler}
                />
            </div>
        );
    }
}

export default PasswordInput;
